module.exports = __webpack_public_path__ + "images/emoji/rabbit2.93a608b554e455677e86.png";